export default __webpack_public_path__ + "static/media/rightInActive.54b0c7f6.svg";